import React, { useEffect, useMemo, useState } from 'react';
import getService from 'services/serviceDiscovery';
import { SERVICE_TYPE } from 'constants/index';
import { LegoTable, buildCollectionsQueryString } from 'utils';
import { useLegoTable, useRouteChangeEventChannelEmitter } from 'hooks';
import EntityList from 'components/EntityList/EntityList';
import Suspend from 'UI/Suspend/Suspend';
import { PageLoader } from 'UI';
import { useNativeObjectsState, useFreshdeskContextState } from 'store';

export default function Entities() {
  useRouteChangeEventChannelEmitter();
  const { getCollections } = useFreshdeskContextState();
  const collectionsQueryString = useMemo(() => buildCollectionsQueryString(getCollections()), [getCollections]);
  const entityTableInstance = useMemo(() => {
    return new LegoTable.Builder().setService(getService(SERVICE_TYPE.ENTITY)).setDataField('schemas').withPagePagination().setBaseQueryString(collectionsQueryString).build();
  }, [collectionsQueryString]);
  const { tableState, fetchList: fetchEntities, onPageChange } = useLegoTable(entityTableInstance);
  const nativeObjectData = useNativeObjectsState();
  const { loaded, idLookup } = nativeObjectData;
  const [initialLoaded, setInitialLoaded] = useState(false);
  useEffect(() => {
    Promise.resolve(fetchEntities()).finally(() => setInitialLoaded(true));
  }, [fetchEntities]);
  const { isLoading, records: entities, error, currentPage, totalRecords } = tableState;

  return (
    <>
      <Suspend isLoading={!initialLoaded || !loaded} fallback={<PageLoader />}>
        <EntityList
          entities={entities}
          error={error}
          idLookup={idLookup}
          fetchEntities={fetchEntities}
          isLoading={isLoading}
          paginationInfo={{ page: currentPage, perPage: entityTableInstance.getPageSize(), total: totalRecords }}
          onPageChange={onPageChange}
        />
      </Suspend>
    </>
  );
}
